import { render, staticRenderFns } from "./GuardianshipBasics.vue?vue&type=template&id=04a036ba&scoped=true"
import script from "./GuardianshipBasics.vue?vue&type=script&lang=js"
export * from "./GuardianshipBasics.vue?vue&type=script&lang=js"
import style0 from "./GuardianshipBasics.vue?vue&type=style&index=0&id=04a036ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a036ba",
  null
  
)

export default component.exports